angular.module('dpw.components')
    .factory('ReportsQueryModel', function () {
        /**
         * Query Model
         *
         * @param {Array} items - Model data.
         * @param {Object} [options] - Options.
         * @param {Boolean} [options.lazy=false] - Lazy to add `virtual` props.
         * @param {Array} [options.props]  - Dynamic model properties. Items in
         *                                   props array is { name: String, value: String | Function }
         * @constructor
         */
        var QueryModel = function (items, options) {
            this.items = items || [];
            options = options || {};
            this.props = options.props || [];
            this.isLazyVirtualization = options.lazy;

            // Store a copy for resetting
            this._initialItems = _.clone(this.items, true);

            // Generate virtual properties
            !this.isLazyVirtualization && this.virtual();
        };

        QueryModel.prototype.all = function () {
            return this.items;
        };

        QueryModel.prototype.first = function () {
            return this.items[0];
        };

        QueryModel.prototype.last = function () {
            return this.items[this.items.length - 1];
        };

        /**
         * Get item by id or property specified via #prop.
         *
         * @param {String} value - Value to search.
         * @param {String} [prop=id] - prop to search
         * @returns {*}
         */
        QueryModel.prototype.get = function (value, prop) {
            prop = prop || 'id';

            return _.find(this.items, function (it) {
                return it[prop] === value;
            });
        };

        QueryModel.prototype.prop = function (key, value, index) {
            var items = this.items;

            if (!_.isUndefined(index)) {
                items = this.items[index] ? [this.items[index]] : [];
            }

            _.each(items, function (item) {
                if (item.virtual === false) {
                    return;
                }
                item[key] = _.isFunction(value) ? value(item) : value;
            });
        };

        /**
         * Add item to model data.
         *
         * @param {Object} item - Item to add
         * @param {Boolean} [selected] - Set this item as selected
         * @returns {*} Item
         */
        QueryModel.prototype.add = function (item, selected) {
            var index = this.items.length;
            var self = this;

            !item.id && (item.id = index.toString());
            this.items.push(item);

            // Add virtual properties.
            _.each(this.props, function (prop) {
                self.prop(prop.name, prop.value, index);
            });

            selected && this.select(item.id);

            return item;
        };

        /**
         * Remove item from model data.
         *
         * @param {Function} filter - every item will be passed to this function as a parameter,
         *                            and the item of which the return is true will be removed.
         */
        QueryModel.prototype.remove = function (filter) {
            _.remove(this.items, filter);
        };

        /**
         * Get/Set selected item.
         *
         * @param {String} [selected] - Selected item.
         * @param {String} [prop=id]  - Selected by item's id or #prop.
         */
        QueryModel.prototype.select = function (selected, prop) {
            if (!_.isUndefined(selected)) {
                prop = prop || 'id';

                _.forEach(this.items, function (item) {
                    item.selected = !item.disabled && item[prop] === selected;
                });
            }

            _.every(this.items, 'selected', false) && this.select(_.get(_.find(this.items, 'isDefault'), 'id'));

            return _.find(this.items, 'selected');
        };

        /**
         * Add virtual props to Model items
         */
        QueryModel.prototype.virtual = function () {
            var self = this;

            _.each(this.props, function (prop) {
                self.prop(prop.name, prop.value);
            });

            return this;
        };

        QueryModel.prototype.reset = function () {
            this.items = _.clone(this._initialItems, true);

            !this.isLazyVirtualization && this.virtual();

            return this;
        };

        return QueryModel;
    })

    .factory('reportsModels', ['ReportsQueryModel', function (QueryModel) {
        return {
            durations: new QueryModel(
                [
                    {id: '0', value: 30 * 24, label: 'Last 30 Days'},
                    {id: '1', value: 7 * 24, label: 'Last 7 Days', selected: true, isDefault: true},
                    {id: '2', value: 24, label: 'Latest 24 Hours'}
                ],
                {
                    props: [
                        {
                            name: 'to',
                            value: function () {
                                return new Date();
                            }
                        },
                        {
                            name: 'from',
                            value: function (item) {
                                return moment(item.to).subtract(item.value, 'hours');
                            }
                        }
                    ],
                    lazy: true
                }
            ),
            types: new QueryModel([
                {id: 'request', value: 'request', label: 'API Calls', selected: true, isDefault: true},
                {id: 'code', value: 'code', label: 'End Points'},
                {id: 'permission', value: 'permission', label: 'Scopes'},
                {id: 'time', value: 'time', label: 'Response Times'}
            ]),
            contexts: _.assign(new QueryModel([
                {id: 'Production', value: 'Production', text: 'Production', selected: true, isDefault: true, disabled: false}
            ]), {
                update: function () {
                    var production = _.find(this.items, 'id', 'Production');

                    production.isDefault = true;
                    production.selected = true;
                    production.disabled = false;
                }
            })
        };
    }])

    .factory('ReportsDuration', ['reportsUtils', function (reportsUtils) {
        function Duration(from, to) {
            var self = this;
            // Use UTC timezone in all types and durations
            this.from = moment.utc(from);
            this.to = moment.utc(to);

            var isDays = this.size('hours') > 24;
            var startOf = isDays ? 'days' : 'hours';

            initElsDuration();

            function initElsDuration() {
                var subtraction = self.to.diff(self.from, 'days');

                var dayStarted = self.to.hours() > 0;

                if (subtraction > 1 && dayStarted) {
                    subtraction--;
                }
                self.from = moment(self.to).startOf(startOf).subtract(subtraction, 'days');
                self.to = self.to.startOf('hours');
            }
        }


        Duration.prototype.size = function (metrics) {
            metrics = metrics || 'days';
            return Math.ceil(this.to.diff(this.from, metrics, true));
        };

        Duration.prototype.update = function (diff) {
            this.to = moment().minutes(0).seconds(0);
            diff > 24 && this.to.hours(0);
            this.from = moment(this.to).subtract(diff, 'hours');

            // Add 1 day to meet the requirement of sumologic query
            this.size() > 1 && this.from.add(1, 'days');
        };

        return Duration;
    }])

    .factory('ReportsSummary', [function () {

        /**
         * Summary Class
         *
         * @param {Object} duration - Reports duration, instance of ReportsDuration
         * @param {Object} [options] - Options
         * @param {String} [options.timeFormat] - Time format
         * @constructor
         */
        function Summary(duration) {
            this.duration = duration;
            this.dateFormat = 'YYYY/MM/DD';
            this.timeFormat = 'HH:mm:ss';

            this.fromDateEl = '.application-query-summary-from-date';
            this.fromTimeEl = '.application-query-summary-from-time';
            this.toDateEl = '.application-query-summary-to-date';
            this.toTimeEl = '.application-query-summary-to-time';
            this.durationTipEl = '.application-query-summary-duration-tooltip';
            this.dataEl = '.application-query-summary-data';

            this.items = [];
        }

        Summary.prototype.data = function (data, filter) {
            filter(this, data);
        };
        Summary.prototype.render = function () {
            var duration = this.duration;
            var dateFormat = this.dateFormat;
            var timeFormat = this.timeFormat;

            var from = moment(duration.from);
            var to = moment(duration.to);

            to.subtract(1, 'seconds');

            $(this.fromDateEl).text(from.format(dateFormat));
            $(this.fromTimeEl).text(from.format(timeFormat));
            $(this.toDateEl).text(to.format(dateFormat));
            $(this.toTimeEl).text(to.format(timeFormat));
            var $tooltipEl = $(this.durationTipEl);

            duration.size() > 1 ? $tooltipEl.css('display', 'inline-block') : $tooltipEl.hide();

            $(this.dataEl).html(
                _.reduce(this.items, function (html, item) {
                    return html + (
                        '<div class="application-query-summary-data-item">' +
                        item.label +
                        '<span class="' + item.label.toLowerCase() + '">' +
                        item.value +
                        '</span>' +
                        '</div>'
                    );
                }, '')
            );
        };
        Summary.prototype.destroy = function () {
            $(this.durationTipEl).hide();
            $(this.fromDateEl).html('');
            $(this.fromTimeEl).html('');
            $(this.toDateEl).html('');
            $(this.toTimeEl).html('');
            $(this.dataEl).html('');
        };

        return Summary;
    }])

    .directive('reportsStackLegend', [function () {
        return {
            restrict: 'A',
            scope: true,
            controller: ['$scope', function ($scope) {
                var self = this;
                var config = $scope.config;
                var chart = config.chart;
                var initialStatus = config.initialStatus;
                var chartGroups = config.groupByStatusCodes ? createChartGroups() : [config.chartValues];

                this.legendTypes = [
                    {
                        id: 'Grouped',
                        checked: true,
                        iconClass: 'icon-icon_group',
                        action: function () {
                            chart.groups([]);
                        }
                    },
                    {
                        id: 'Stacked',
                        iconClass: 'icon-icon_stack',
                        action: function () {
                            chart.groups(chartGroups);
                        }
                    }
                ];

                initialStatus && selectStatus(initialStatus);

                !_.isEqual(chart.groups(), chartGroups) && updateChart();

                this.onClickHandler = function (id) {
                    selectStatus(id);
                    updateChart();

                    var callback = config.onClickCallback;
                    _.isFunction(callback) && callback();
                };

                this.additionalMarginValue = (function () {
                    var axisClass = config.isChartRotated ? '.c3-axis-x' : '.c3-axis-y';
                    var elemAxis = d3.select(config.chartBindTo + ' ' + axisClass).node();
                    if (!elemAxis) {
                        return;
                    }
                    var additionalMargin = elemAxis.getBBox().width;
                    return additionalMargin + 'px';
                })();

                function selectStatus(id) {
                    _.forEach(self.legendTypes, function (item) {
                        item.checked = item.id === id;
                    });
                }

                function updateChart() {
                    var updateFn = _.get(_.find(self.legendTypes, 'checked'), 'action');
                    updateFn();
                }

                function createChartGroups() {
                    var groups = {
                        '2XX': [],
                        '3XX': [],
                        '4XX': [],
                        '5XX': []
                    };

                    _.forEach(config.chartValues, function (v) {
                        var startsWith = v.substr(0, 1);
                        var key = startsWith + 'XX';
                        var group = groups[key];

                        _.isArray(group) && group.push(v);
                    });

                    return _.filter(groups, function (v) {
                        return v.length > 0;
                    });
                }
            }],
            controllerAs: 'ctrl',
            templateUrl: 'reports-stack-legend.html'
        };
    }])

    .factory('reportsStackLegendGenerator', ['$rootScope', '$compile', function ($rootScope, $compile) {
        return function (legendBindTo, chartBindTo, chart, chartValues, options) {
            var scope = $rootScope.$new();
            scope.config = {
                chart: chart,
                chartBindTo: chartBindTo,
                chartValues: chartValues,
                initialStatus: options.initialStatus,
                isChartRotated: options.isChartRotated,
                onClickCallback: options.onClickCallback,
                groupByStatusCodes: options.groupByStatusCodes
            };

            var $dom = $compile($('<div reports-stack-legend></div>'))(scope);

            $(legendBindTo).html($dom);

            return {
                destroy: function () {
                    scope.$destroy();
                    $(legendBindTo).html('');
                }
            };
        };
    }])

    .directive('reportsCustomLegend', [function () {
        return {
            restrict: 'A',
            scope: true,
            controller: ['$scope', function ($scope) {
                var chart = $scope.chart;

                this.onClickHandler = function (legendItem) {
                    var id = legendItem.id;

                    // TODO: avoid using internal api of c3.js
                    if (chart.internal.isTargetToShow(id)) {
                        legendItem.checked = false;
                        chart.hide([id]);
                    } else {
                        legendItem.checked = true;
                        chart.show([id]);
                    }
                };
            }],
            controllerAs: 'ctrl',
            templateUrl: 'reports-custom-legend.html'
        };
    }])

    .factory('reportsCustomLegendGenerator', ['$rootScope', '$compile', function ($rootScope, $compile) {
        return function (bindTo, chart, ids, options) {
            var legendItems = [];
            var idLabelMapping = options.idLabelMapping || {};
            var messages = options.messages || [];

            _.forEach(ids, function (id) {
                legendItems.push({
                    id: id,
                    label: getLabel(id),
                    color: chart.color(id),
                    message: getMessage(id),
                    checked: true
                });
            });

            var scope = $rootScope.$new();
            scope.legendItems = legendItems;
            scope.chart = chart;

            var $dom = $compile($('<div reports-custom-legend class="legend"></div>'))(scope);

            $(bindTo).append($dom);

            function getLabel(id) {
                return idLabelMapping[id] || id;
            }

            function getMessage(id) {
                var msgItem;

                if (messages.startsWith) {
                    msgItem = _.find(messages, function (item) {
                        return _.startsWith(id, item.startsWith);
                    });
                } else {
                    msgItem = _.find(messages, 'id', id);
                }

                return _.get(msgItem, 'message', '');
            }
        };
    }])

    .factory('ReportsGeneratorAPICall', [
        'api', 'ReportsDuration', 'ReportsSummary', 'reportsUtils', 'reportsStackLegendGenerator',
        function (api, ReportsDuration, ReportsSummary, reportsUtils, reportsStackLegendGenerator) {

            /**
             * APICallGenerator Class.
             *
             * @param {String} options.appId    - Application Id.
             * @param {Object} options.duration - Query Duration.
             * @param {String} options.context  - Query Context : Production
             * @param {String} options.bindto   - Element to which chart is rendered.
             * @param {Function} [options.onClick] - Function to invoke when clicking on chart item.
             * @param {Boolean} [options.noLoading] - Whether to show loading state or not.
             * @param {Function} [options.drawCallback] - Callback after draw finished.
             * @constructor
             */
            function APICallGenerator(options) {
                this.bindto = options.bindto;
                this.duration = new ReportsDuration(options.duration.from, options.duration.to);
                this.metrics = this.duration.size() > 1 ? 'date' : 'hour';
                this.summary = new ReportsSummary(this.duration);
                this.context = options.context;
                this.onChartClick = this.metrics === 'date' && _.isFunction(options.onClick) ?
                    options.onClick : function () {
                    };
                this.noLoading = !!options.noLoading;
                this.appId = options.appId;
                this.retrieve = options.retrieve;
                this.drawCallback = options.drawCallback;
                this.initialized = false;
            }

            APICallGenerator.prototype.init = function () {
                this.fetch(this.appId);
            };

            APICallGenerator.prototype.fetch = function (appId) {
                var self = this;
                var params = {
                    applicationId: appId,
                    startTime: self.duration.from.format(),
                    endTime: self.duration.to.format(),
                    metrics: self.metrics,
                    appStatus: self.context,
                    noLoading: self.noLoading,
                    retrieve: self.retrieve
                };


                if (self.retrieve) {
                    params.cacheStartTimes = reportsUtils.getCacheStartTimes();
                }
                api.call(api.reports.request(params), function (response) {
                    reportsUtils.onSumoConnect(response, function (response) {

                        self.setData(response);
                        self.setColors();

                        self.summary.data(self.data, function dataFilter(summary, data) {
                            var getSummaryCount = function (countData, key) {
                                return _.reduce(countData, function (sum, count) {
                                    return sum + count[key];
                                }, 0);
                            };
                            summary.items = [
                                {label: 'Total', value: getSummaryCount(data, 'total')},
                                {label: 'Success', value: getSummaryCount(data, 'success')},
                                {label: 'Error', value: getSummaryCount(data, 'error')}
                            ];
                        });
                        self.initialized = true;
                        self.retrieveDate = response.retrieveDate;

                        self.render();
                    });
                });
            };

            APICallGenerator.prototype.render = function () {
                this.summary.render();
                this.updateRetrieveDate(this.retrieveDate);
                this.draw();
                _.isFunction(this.drawCallback) && this.drawCallback();
            };

            APICallGenerator.prototype.CATEGORIES = ['error', 'success'];

            APICallGenerator.prototype.setData = function (responseData) {
                var data = [];
                var totalCount = responseData.requestCount;
                var successCount = responseData.successCount;
                var errorCount = responseData.errorCount;

                var isHourly = this.duration.size() <= 1;
                var metrics = isHourly ? 'hours' : 'days';
                var format = isHourly ? 'YYYY-MM-DDTHH:mm:ss' : 'YYYY-MM-DD';
                var durationSize = isHourly ? 24 : this.duration.size();

                // Use two pointers to eliminate the inconsistency between the response data and the data to display.
                var pointer = moment(this.duration.from);

                for (var i = 0; i < durationSize; i++) {
                    var datetime = pointer.format(format);

                    data.push({
                        datetime: datetime,
                        total: getCountData(totalCount, datetime),
                        success: getCountData(successCount, datetime),
                        error: getCountData(errorCount, datetime)
                    });

                    pointer.add(1, metrics);
                }

                this.data = data;

                function getCountData(collection, datetime) {
                    return _.get(_.find(collection, 'datetime', datetime), 'count') || 0;
                }
            };

            APICallGenerator.prototype.setColors = function () {
                this.colors = {
                    success: '#6ad067',
                    error: '#ff1e1e',
                    total: '#585858'
                };
            };

            APICallGenerator.prototype.groupLegend = function () {
                var self = this;
                var options = {
                    initialStatus: 'Stacked',
                    onClickCallback: function () {
                        if (_.every(self.categoryLegends, 'checked', false)) {
                            self.hideYAxisTickValues();
                        }
                    }
                };
                this.stackLegendInstance = reportsStackLegendGenerator(
                    '.legend-wrap', this.bindto, this.chart, this.CATEGORIES, options);
            };

            APICallGenerator.prototype.categoryLegend = function () {
                var self = this;
                this.categoryLegends = [];

                this.CATEGORIES.forEach(function (v) {
                    self.categoryLegends.push({
                        id: v,
                        checked: true
                    });
                });

                d3.select(self.bindto).append('div')
                    .attr('class', 'legend').selectAll('span')
                    .data(self.CATEGORIES)
                    .enter().append('span')
                    .attr('data-id', function (id) {
                        return id;
                    })
                    .html(function (id) {
                        var color = self.chart.color(id);
                        return '<i style="border-color: ' + color + '; background: ' + color + ';"></i>' + _.capitalize(id);
                    })
                    .on('click', function (id) {
                        var legend = _.find(self.categoryLegends, 'id', id);
                        var selector = '.legend span[data-id=' + id + '] i';
                        if (legend.checked) {
                            hideData(id, legend, selector);
                        } else {
                            showData(id, legend, selector);
                        }
                    });

                function hideData(id, legend, selector) {
                    $(selector).css('background', '#fff');
                    self.chart.hide([id]);
                    legend.checked = false;

                    if (_.every(self.categoryLegends, 'checked', false)) {
                        self.hideYAxisTickValues();
                    }
                }

                function showData(id, legend, selector) {
                    $(selector).css('background', self.chart.color(id));
                    self.chart.show([id]);
                    legend.checked = true;
                }
            };

            APICallGenerator.prototype.hideYAxisTickValues = function () {
                var chartInternal = this.chart.internal;
                chartInternal.yAxis.tickValues([]);
                chartInternal.axis.redraw(chartInternal.axis.generateTransitions(0), false);
            };

            APICallGenerator.prototype.timeFormat = '';

            APICallGenerator.prototype.draw = function () {
                var self = this;
                var duration = this.duration;

                this.chart = c3.generate({
                    bindto: self.bindto,
                    size: {
                        width: 720
                    },
                    data: {
                        x: 'x',
                        xFormat: duration.size() > 1 ? '%Y-%m-%d' : '%Y-%m-%dT%H:%M:%S',
                        json: self.data,
                        keys: {
                            x: 'datetime',
                            value: self.CATEGORIES
                        },
                        type: 'bar',
                        order: function (a, b) {
                            var cate = self.CATEGORIES;
                            return cate.indexOf(b.id) - cate.indexOf(a.id);
                        },
                        groups: [self.CATEGORIES],
                        colors: self.colors
                    },
                    axis: {
                        x: {
                            label: {
                                text: duration.size() > 1 ? 'Day' : 'Hour',
                                position: 'outer-right'
                            },
                            type: 'timeseries',
                            tick: {
                                fit: true,
                                format: function (x) {
                                    var format = self.duration.size() <= 1 ? '%H:%M' : '%Y/%m/%d';
                                    var formatter = d3.time.format(format);
                                    var tickValue = formatter(x);

                                    // Prevent the tick value from breaking into multiline accidentally.
                                    return [tickValue];
                                },
                                values: null //duration.diff() === 0 ? self.tickValues : null
                            }
                        },
                        y: {
                            label: {
                                text: 'Count',
                                position: 'outer-top'
                            },
                            tick: {
                                values: reportsUtils.tickValuesGenerator
                            }
                        }
                    },
                    legend: {
                        show: false
                    },
                    tooltip: {
                        contents: function (d, defaultTitleFormat, defaultValueFormat, color) {

                            d[1] && d.push({
                                id: 'total',
                                index: 3,
                                name: 'Total',
                                value: d[0].value + d[1].value
                            });

                            var contents = '<table class="c3-tooltip">';
                            var format = duration.size() <= 1 ? 'YYYY/MM/DD HH:mm:ss' : 'YYYY/MM/DD';

                            d.forEach(function (item, index) {
                                if (index === 0) {
                                    contents = contents + '<tr>' +
                                        '<th colspan="2">' + moment(item.x).format(format) + '</th>' +
                                        '</tr>';
                                }
                                contents = contents + '<tr>' +
                                    '<td class="name">' +
                                    '<span style="background-color: ' + color(item) + '"></span>' +
                                    _.capitalize(item.name) +
                                    '</td>' +
                                    '<td class="value">' + item.value + '</td>' +
                                    '</tr>';
                            });

                            return contents;
                        }
                    },
                    onrendered: function () {
                        var chartInternalData = this.data;

                        // Attach onClick listeners after the category legend was initialized.
                        setTimeout(attachClickListener, 0);

                        // Make the data column and its above blank area available to click.
                        function attachClickListener() {
                            var dataList = [];
                            var categoryLegendChecked = _.some(self.categoryLegends, 'checked', true);

                            if (categoryLegendChecked && chartInternalData.targets.length > 0) {
                                var internalData = chartInternalData.targets[0].values;
                                internalData.forEach(function (d, idx) {
                                    dataList.push({
                                        index: idx,
                                        d: d
                                    });
                                });

                                dataList.forEach(function (data) {
                                    $('.c3-event-rect-' + data.index).on('click', function () {
                                        self.onChartClick(data.d);
                                    });
                                });
                            }
                        }
                    }
                });

                this.groupLegend();
                this.categoryLegend();
            };

            APICallGenerator.prototype.destroy = function () {
                this.summary.destroy();

                if (this.stackLegendInstance && _.isFunction(this.stackLegendInstance.destroy)) {
                    this.stackLegendInstance.destroy();
                }

                if (this.chart instanceof c3.chart.fn.constructor) {
                    this.chart.destroy();
                }
            };

            APICallGenerator.prototype.updateRetrieveDate = function () {
                reportsUtils.updateRetrieveDate(this.retrieveDate);
            };

            return APICallGenerator;
        }
    ])

    .factory('ReportsGeneratorEndPoints', [
        'api', 'ReportsDuration', 'ReportsSummary', 'reportsUtils', 'reportsCustomLegendGenerator', 'reportsStackLegendGenerator', 'dpwStorage',
        function (api, ReportsDuration, ReportsSummary, reportsUtils, reportsCustomLegendGenerator, reportsStackLegendGenerator, dpwStorage) {

            /**
             * EndPointsGenerator Class.
             *
             * @param {String} options.appId    - Application Id.
             * @param {Object} options.duration - Query Duration.
             * @param {String} options.context  - Query Context : Production
             * @param {String} options.bindto   - Element to which chart is rendered.
             * @param {Boolean} [options.noLoading] - Whether to show loading state or not.
             * @constructor
             */
            function EndPointsGenerator(options) {
                this.bindto = options.bindto;
                this.duration = new ReportsDuration(options.duration.from, options.duration.to);
                this.metrics = this.duration.size() > 1 ? 'date' : 'hour';
                this.summary = new ReportsSummary(this.duration);
                this.context = options.context;
                this.appId = options.appId;
                this.noLoading = !!options.noLoading;
                this.retrieve = options.retrieve;
                this.initialized = false;
            }

            EndPointsGenerator.prototype.init = function () {
                this.fetch(this.appId);
            };

            EndPointsGenerator.prototype.fetch = function (appId) {
                var self = this;
                var duration = this.duration;
                var params = {
                    applicationId: appId,
                    startTime: duration.from.format(),
                    endTime: duration.to.format(),
                    metrics: self.metrics,
                    appStatus: self.context,
                    noLoading: self.noLoading,
                    retrieve: self.retrieve
                };

                if (self.retrieve) {
                    params.cacheStartTimes = reportsUtils.getCacheStartTimes();
                }

                api.call(api.reports.statusCode(params), function (response) {
                    reportsUtils.onSumoConnect(response, function (response) {
                        self.setData(response.data);
                        self.colors = self.generateColors();
                        self.initialized = true;
                        self.retrieveDate = response.retrieveDate;
                        self.render();
                    });
                });
            };

            EndPointsGenerator.prototype.render = function () {
                this.summary.render();
                this.updateRetrieveDate(this.retrieveDate);
                this.draw();
                this.stackLegend();
                this.legend();
            };

            EndPointsGenerator.prototype.setData = function (data) {
                var chartData = [];
                var chartValues = [];

                Array.isArray(data) && data.forEach(function (item) {
                    var api = item.api;
                    Array.isArray(item.apiMethodDetails) && item.apiMethodDetails.forEach(function (detail) {
                        var name = api + ' ' + detail.method;
                        var chartItem = _.find(chartData, function (data) {
                            return data.name === name;
                        });
                        var isAPIEndPointExists = !!chartItem;

                        !isAPIEndPointExists && (chartItem = {
                            name: name
                        });
                        Array.isArray(detail.statusCounts) && detail.statusCounts.forEach(function (status) {
                            chartItem[status.status] = status.count;
                            chartData.forEach(function (cd) {
                                if (!cd[status.status]) {
                                    cd[status.status] = null;
                                }
                            });
                            (chartValues.indexOf(status.status) === -1) && chartValues.push(status.status);
                        });
                        !isAPIEndPointExists && chartData.push(chartItem);
                    });
                });

                this.chartData = _.sortBy(chartData, 'name');

                // Prevent the names from being cut off
                this.chartData.forEach(function (cd) {
                    cd.name = cd.name.split(' ');
                });

                this.chartValues = chartValues.sort();
            };

            EndPointsGenerator.prototype.generateColors = function () {
                var colors = {};
                var CODE_COLORS = ['#e77a74', '#b385c7', '#efcf5b', '#6aafdd', '#60ccb7'];

                this.chartValues.forEach(function (cate, index) {
                    colors[cate] = CODE_COLORS[index];
                });

                return colors;
            };

            EndPointsGenerator.prototype.stack = function () {
                if (this.stacked) {
                    this.chart.groups(this.stacked);
                    return;
                }

                var stacked = [
                    ['200'],
                    ['300'],
                    ['400'],
                    ['500']
                ];
                var code;

                for (var p in this.columns) {
                    if (this.columns.hasOwnProperty(p)) {
                        code = this.columns[p][0];
                        switch (code.substring(0, 1)) {
                            case '2':
                                stacked[0].push(code);
                                break;
                            case '3':
                                stacked[1].push(code);
                                break;
                            case '4':
                                stacked[2].push(code);
                                break;
                            case '5':
                                stacked[3].push(code);
                                break;
                        }
                    }
                }
                this.stacked = stacked;
                this.chart.groups(this.stacked);
            };

            EndPointsGenerator.prototype.group = function () {
                this.chart.groups([]);
            };

            EndPointsGenerator.prototype.draw = function () {
                var self = this;
                var colorStorage = {
                    _usedColorList: [],
                    keyName: 'endpointsUsedColorList',
                    init: function () {
                        this._usedColorList = JSON.parse(dpwStorage.getItem(this.keyName) || '[]');
                    },
                    addUsedColor: function (colorItem) {
                        var usedColorList = this.getUsedColorList();
                        usedColorList.push(colorItem);
                        dpwStorage.setItem(this.keyName, JSON.stringify(usedColorList), false);
                    },
                    getUsedColorList: function () {
                        return this._usedColorList;
                    }
                };
                colorStorage.init();

                var colorList = [
                    '#6ad067', '#5bccb7', '#008e74', '#68aedf',
                    '#055a95', '#8eb2f3', '#b485c8', '#660e8c',
                    '#ffb8e0', '#a100a1', '#fba0a0', '#903500',
                    '#f0d051', '#bc9500', '#c7c7c7', '#7f7f7f'
                ];
                var usedColorList = colorStorage.getUsedColorList();
                var codeColorMapping = {
                    '200': '#058300',
                    '300': '#0643aa',
                    '429': '#e01100',
                    '500': '#ff843d'
                };

                this.chart = c3.generate({
                    bindto: self.bindto,
                    size: {
                        width: 884,
                        height: 600
                    },
                    data: {
                        json: self.chartData,
                        type: 'bar',
                        keys: {
                            x: 'name',
                            value: self.chartValues
                        },
                        color: function (color, d) {
                            var code = _.isString(d) ? d : d.id;
                            var colorForCode = codeColorMapping[code] || _.get(_.find(usedColorList, 'code', code), 'color');
                            return colorForCode || randomColor(code);

                            function randomColor(code) {
                                var colorIndex = getAvailableIndex();
                                var colorValue = colorIndex !== -1 ? colorList[colorIndex] : color;
                                colorStorage.addUsedColor({
                                    index: colorIndex,
                                    color: colorValue,
                                    code: code
                                });

                                return colorValue;

                                function getAvailableIndex() {
                                    if (usedColorList.length >= colorList.length) {
                                        return -1;
                                    }

                                    var colorIndex;
                                    do {
                                        colorIndex = generateRandomIndex();
                                    } while (_.find(usedColorList, 'index', colorIndex));

                                    return colorIndex;

                                    function generateRandomIndex() {
                                        return _.random(0, colorList.length - 1);
                                    }
                                }
                            }
                        }
                    },
                    bar: {
                        width: 8
                    },
                    axis: {
                        rotated: true,
                        x: {
                            type: 'category',
                            tick: {
                                format: function (d) {
                                    var catNames = _.clone(this.api.categories()[d]);

                                    if (!Array.isArray(catNames)) {
                                        return catNames;
                                    }

                                    var result = [];
                                    var apiName = catNames[0] || '';
                                    var splittedApiNames = apiName.split('/');
                                    var perLine = 5;
                                    if (splittedApiNames.length > perLine) {
                                        var maxLines = Math.ceil(splittedApiNames.length / perLine);
                                        for (var i = 0; i < maxLines; i++) {
                                            var start = i * perLine;
                                            var end = (i + 1) * perLine;
                                            var line = splittedApiNames.slice(start, end).join('/');
                                            if ((i + 1) !== maxLines) {
                                                line = line + '/';
                                            }
                                            result.push(line);
                                        }
                                    } else {
                                        result.push(apiName);
                                    }

                                    result = result.concat(catNames.slice(1));
                                    return result;
                                }
                            }
                        },
                        y: {
                            label: {
                                text: 'Request Count',
                                position: 'outer-right'
                            },
                            tick: {
                                values: reportsUtils.tickValuesGenerator
                            },
                            default: [0, 9]
                        },
                        y2: {
                            //show: true,
                            label: {
                                text: 'Request Count',
                                position: 'outer-right'
                            }
                        }
                    },
                    legend: {
                        show: false
                    },
                    grid: {
                        y: {
                            show: true
                        }
                    },
                    tooltip: {
                        format: {
                            title: function (idx) {
                                var name = self.chartData[idx].name;
                                return Array.isArray(name) ? name.join(', ') : name;
                            }
                        }
                    },
                    onrendered: function () {
                        var self = this;
                        d3.select(this.config.bindto)
                            .selectAll(".c3-axis-x .tick text")
                            .each(function (d) {
                                var title = d3.select(this).select("title");
                                if (title.empty()) {
                                    title = d3.select(this).append("title");
                                }
                                title.text(self.api.categories()[d].join(', '));
                            })
                        ;
                    }
                });

                resizeChart();

                function resizeChart() {
                    var minHeight = 600;

                    var AxisYHeight = (function () {
                        var elemAxis = d3.select(self.bindto + ' .c3-axis-y').node();
                        if (!elemAxis) {
                            return 0;
                        }
                        return elemAxis.getBBox().height;
                    })();

                    var chartHeight = self.chartData.length * (self.chartValues.length * 8 + 28) + AxisYHeight;

                    self.chart.resize({
                        width: 720,
                        height: chartHeight > minHeight ? chartHeight : minHeight
                    });
                }
            };

            EndPointsGenerator.prototype.stackLegend = function () {
                var options = {
                    initialStatus: 'Grouped',
                    isChartRotated: true,
                    groupByStatusCodes: true
                };
                this.stackLegendInstance = reportsStackLegendGenerator(
                    '.legend-wrap', this.bindto, this.chart, this.chartValues, options);
            };

            EndPointsGenerator.prototype.legend = function () {
                this.customLegend(this.bindto, this.chart, this.chartValues);
            };

            EndPointsGenerator.prototype.customLegend = function (selector, chart, categories) {
                var options = {
                    messages: [
                        {startsWith: '2', message: 'Successful requests'},
                        {startsWith: '3', message: 'Redirected requests'},
                        {startsWith: '4', message: 'Client errors'},
                        {startsWith: '5', message: 'Server errors'}
                    ]
                };
                options.messages.startsWith = true;
                reportsCustomLegendGenerator(selector, chart, categories, options);

                reportsUtils.loadStickyLegend();
            };

            EndPointsGenerator.prototype.destroy = function () {
                reportsUtils.unloadStickyLegend();
                this.summary.destroy();

                if (this.stackLegendInstance && _.isFunction(this.stackLegendInstance.destroy)) {
                    this.stackLegendInstance.destroy();
                }

                if (this.chart instanceof c3.chart.fn.constructor) {
                    this.chart.destroy();
                }
            };

            EndPointsGenerator.prototype.updateRetrieveDate = function () {
                reportsUtils.updateRetrieveDate(this.retrieveDate);
            };

            return EndPointsGenerator;
        }
    ])

    .factory('ReportsGeneratorPermissions', [
        '$window', '$q', 'api', 'ReportsDuration', 'ReportsSummary', 'reportsUtils', 'reportsCustomLegendGenerator', 'reportsStackLegendGenerator', 'dpwStorage',
        function ($window, $q, api, ReportsDuration, ReportsSummary, reportsUtils, reportsCustomLegendGenerator, reportsStackLegendGenerator, dpwStorage) {

            /**
             * PermissionsGenerator Class
             *
             * @param {String} options.appId    - ApplicationId
             * @param {Object} options.duration - Query duration
             * @param {String} options.context  - Query Context: Production
             * @param {String} options.bindto   - Element to which chart will be rendered
             * @param {Boolean} [options.noLoading] - Whether to show loading state or not.
             * @constructor
             */
            function PermissionsGenerator(options) {
                this.bindto = options.bindto;
                this.duration = new ReportsDuration(options.duration.from, options.duration.to);
                this.metrics = this.duration.size() > 1 ? 'date' : 'hour';
                this.summary = new ReportsSummary(this.duration);
                this.context = options.context;
                this.appId = options.appId;
                this.noLoading = !!options.noLoading;
                this.retrieve = options.retrieve;
                this.initialized = false;
            }

            PermissionsGenerator.prototype.init = function () {
                this.fetch(this.appId);
            };

            PermissionsGenerator.prototype.fetch = function (appId) {
                var self = this;
                var duration = this.duration;
                var params = {
                    applicationId: appId,
                    startTime: duration.from.format(),
                    endTime: duration.to.format(),
                    metrics: self.metrics,
                    appStatus: self.context,
                    noLoading: self.noLoading,
                    retrieve: self.retrieve
                };

                if (self.retrieve) {
                    params.cacheStartTimes = reportsUtils.getCacheStartTimes();
                }


                var apiCallPromise = api.call(api.reports.request(params));
                var permissionPromise = api.call(api.reports.permission(params));

                $q.all([apiCallPromise, permissionPromise]).then(function (responses) {
                    var responseApiCall = _.first(responses);
                    var responsePermission = _.last(responses);

                    reportsUtils.onSumoConnect(responsePermission, function (responsePermission) {
                        self.retrieveDate = responsePermission.retrieveDate;

                        if (!_.isEmpty(responseApiCall.requestCount) && _.isEmpty(responsePermission.data)) {
                            $('.application-query-summary').hide();
                            $('.application-reports-result').hide();
                            $('.application-reports-message').html('No scope in this app');
                            self.updateRetrieveDate(self.retrieveDate);
                        } else {
                            self.data(responsePermission.data);
                            self.initialized = true;
                            self.render();
                        }
                    });
                });
            };

            /**
             * Covert data into chart compatible data format.
             *
             * Result format:
             * [
             *   { name: 'ReadAccounts', 200: 100, 400: 5, 500: 1 }
             *   { name: 'ReadCallLog',  200: 120, 400: null, 500, null }
             * ]
             *
             *
             * @param {Array} data
             */
            PermissionsGenerator.prototype.data = function (data) {
                var self = this;

                this._data = [];
                this._values = [];

                var allStatusCodes = getAllStatusCodes(data);
                var availableStatusCodes = this._values = allStatusCodes.sort();

                _.each(data, function (item) {
                    var chartItem = {
                        name: item.permission
                    };

                    _.each(availableStatusCodes, function (code) {
                        var existing = _.find(item.requests, function (request) {
                            return request.cod === code;
                        });
                        chartItem[code] = existing ? existing.count : null;
                    });

                    self._data.push(chartItem);
                });

                // Prevent the names from being cut off
                _.forEach(self._data, function (d) {
                    d.name = [d.name];
                });

                /**
                 * Get all status codes from server response.
                 *
                 * @param {Array} data
                 * @return {Array}
                 */
                function getAllStatusCodes(data) {
                    return _.reduce(data, function (result, current) {
                        var requests = current.requests;

                        _.each(requests, function (request) {
                            if (_.indexOf(result, request.cod) < 0) {
                                result.push(request.cod);
                            }
                        });

                        return result;
                    }, []);
                }
            };

            PermissionsGenerator.prototype.draw = function () {
                var self = this;

                // TODO: Extract to service - Vi
                var colorStorage = {
                    _usedColorList: [],
                    keyName: 'permissionsUsedColorList',
                    init: function () {
                        this._usedColorList = JSON.parse(dpwStorage.getItem(this.keyName) || '[]');
                    },
                    addUsedColor: function (colorItem) {
                        var usedColorList = this.getUsedColorList();
                        usedColorList.push(colorItem);
                        dpwStorage.setItem(this.keyName, JSON.stringify(usedColorList), false);
                    },
                    getUsedColorList: function () {
                        return this._usedColorList;
                    }
                };
                colorStorage.init();

                var colorList = [
                    '#6ad067', '#5bccb7', '#008e74', '#68aedf',
                    '#055a95', '#8eb2f3', '#b485c8', '#660e8c',
                    '#ffb8e0', '#a100a1', '#fba0a0', '#903500',
                    '#f0d051', '#bc9500', '#c7c7c7', '#7f7f7f'
                ];
                var usedColorList = colorStorage.getUsedColorList();
                var codeColorMapping = {
                    '200': '#058300',
                    '300': '#0643aa',
                    '429': '#e01100',
                    '500': '#ff843d'
                };

                this.chart = c3.generate({
                    bindto: self.bindto,
                    size: {
                        width: 720,
                        height: 600
                    },
                    data: {
                        json: self._data,
                        type: 'bar',
                        order: null,
                        groups: [],
                        keys: {
                            x: 'name',
                            value: self._values
                        },
                        color: function (color, d) {
                            var code = _.isString(d) ? d : d.id;
                            var colorForCode = codeColorMapping[code] || _.get(_.find(usedColorList, 'code', code), 'color');
                            return colorForCode || randomColor(code);

                            function randomColor(code) {
                                var colorIndex = getAvailableIndex();
                                var colorValue = colorIndex !== -1 ? colorList[colorIndex] : color;
                                colorStorage.addUsedColor({
                                    index: colorIndex,
                                    color: colorValue,
                                    code: code
                                });

                                return colorValue;

                                function getAvailableIndex() {
                                    if (usedColorList.length >= colorList.length) {
                                        return -1;
                                    }

                                    var colorIndex;
                                    do {
                                        colorIndex = generateRandomIndex();
                                    } while (_.find(usedColorList, 'index', colorIndex));

                                    return colorIndex;

                                    function generateRandomIndex() {
                                        return _.random(0, colorList.length - 1);
                                    }
                                }
                            }
                        }

                    },
                    bar: {
                        width: 8
                    },
                    axis: {
                        rotated: true,
                        x: {
                            type: 'category'
                        },
                        y: {
                            label: {
                                text: 'Number of API Calls',
                                position: 'outer-right'
                            },
                            tick: {
                                values: reportsUtils.tickValuesGenerator
                            },
                            default: [0, 9]
                        }
                    },
                    legend: {
                        show: false
                    },
                    grid: {
                        y: {
                            show: true
                        }
                    },
                    tooltip: {
                        format: {
                            title: function (idx) {
                                var name = self._data[idx].name;
                                return Array.isArray(name) ? name.join(', ') : name;
                            }
                        }
                    }
                });

                // TODO: Extract to service - Vi
                resizeChart();

                function resizeChart() {
                    var minHeight = 600;

                    var AxisYHeight = (function () {
                        var elemAxis = d3.select(self.bindto + ' .c3-axis-y').node();
                        if (!elemAxis) {
                            return 0;
                        }
                        return elemAxis.getBBox().height;
                    })();

                    var chartHeight = self._data.length * (self._values.length * 8 + 28) + AxisYHeight;

                    self.chart.resize({
                        width: 720,
                        height: chartHeight > minHeight ? chartHeight : minHeight
                    });
                }

                this.stackLegend();
                this.legend(this.bindto, this.chart, this._values);
            };

            PermissionsGenerator.prototype.stackLegend = function () {
                var options = {
                    initialStatus: 'Grouped',
                    isChartRotated: true,
                    groupByStatusCodes: true
                };
                this.stackLegendInstance = reportsStackLegendGenerator(
                    '.legend-wrap', this.bindto, this.chart, this._values, options);
            };

            PermissionsGenerator.prototype.legend = function (selector, chart, categories, labelPrefix) {
                var options = {
                    messages: [
                        {startsWith: '2', message: 'Successful requests'},
                        {startsWith: '3', message: 'Redirected requests'},
                        {startsWith: '4', message: 'Client errors'},
                        {startsWith: '5', message: 'Server errors'}
                    ]
                };
                options.messages.startsWith = true;
                reportsCustomLegendGenerator(selector, chart, categories, options);

                reportsUtils.loadStickyLegend();
            };

            PermissionsGenerator.prototype.render = function () {
                this.summary.render();
                this.updateRetrieveDate(this.retrieveDate);
                this.draw();
            };

            PermissionsGenerator.prototype.destroy = function () {
                this.summary.destroy();

                if (this.stackLegendInstance && _.isFunction(this.stackLegendInstance.destroy)) {
                    this.stackLegendInstance.destroy();
                }

                if (this.chart instanceof c3.chart.fn.constructor) {
                    this.chart.destroy();
                }

                $('.application-query-summary').show();
                $('.application-reports-result').show();
                $('.application-reports-message').html('');
            };

            PermissionsGenerator.prototype.updateRetrieveDate = function () {
                reportsUtils.updateRetrieveDate(this.retrieveDate);
            };


            return PermissionsGenerator;
        }
    ])

    .factory('ReportsGeneratorResponseTime', [
        'api', 'ReportsDuration', 'ReportsSummary', 'reportsUtils', 'reportsCustomLegendGenerator',
        function (api, ReportsDuration, ReportsSummary, reportsUtils, reportsCustomLegendGenerator) {

            /**
             * ResponseTimeGenerator Class.
             *
             * @param {String} options.appId    - Application Id.
             * @param {Object} options.duration - Query Duration.
             * @param {String} options.context  - Query Context : Production
             * @param {String} options.bindto   - Element to which chart is rendered.
             * @param {Boolean} [options.noLoading] - Whether to show loading state or not.
             * @constructor
             */
            function ResponseTimeGenerator(options) {
                this.bindto = options.bindto;
                this.duration = new ReportsDuration(options.duration.from, options.duration.to);
                this.metrics = this.duration.size() > 1 ? 'date' : 'hour';
                this.summary = new ReportsSummary(this.duration);
                this.context = options.context;
                this.appId = options.appId;
                this.noLoading = !!options.noLoading;
                this.retrieve = options.retrieve;
                this.initialized = false;
            }

            ResponseTimeGenerator.prototype.init = function () {
                this.fetch(this.appId);
            };

            ResponseTimeGenerator.prototype.fetch = function (appId) {
                var self = this;
                var duration = this.duration;
                var params = {
                    applicationId: appId,
                    startTime: duration.from.format(),
                    endTime: duration.to.format(),
                    metrics: self.metrics,
                    appStatus: self.context,
                    noLoading: self.noLoading,
                    retrieve: self.retrieve
                };

                if (self.retrieve) {
                    params.cacheStartTimes = reportsUtils.getCacheStartTimes();
                }

                api.call(api.reports.responseTime(params), function (response) {
                    reportsUtils.onSumoConnect(response, function (response) {
                        self.data(response.data);
                        self.initialized = true;
                        self.retrieveDate = response.retrieveDate;
                        self.render();
                    });
                });
            };

            ResponseTimeGenerator.prototype.render = function () {
                this.summary.render();
                this.updateRetrieveDate(this.retrieveDate);
                this.draw();
            };

            ResponseTimeGenerator.prototype.data = function (data) {
                var categories = [];
                var chartData = [];

                this.RESPONSE_TIME_CATEGORY = ['maxtime', 'avgtime', 'pct50time', 'pct95time', 'pct99time'];
                this.RESPONSE_TIME_CATEGORY_LABEL = {
                    maxtime: 'Max Time',
                    avgtime: 'Avg Time',
                    pct50time: '50th Percentile',
                    pct95time: '95th Percentile',
                    pct99time: '99th Percentile'
                };

                _.each(data, function (item) {
                    var api = item.api;

                    _.each(item.methodTimes, function (mt) {
                        var t = {};
                        t.endpoint = api + ' ' + mt.method;
                        categories.push(t.endpoint);

                        _.each(mt.time, function (time) {
                            t[time.type] = Number(time.value).toFixed(2);
                        });

                        chartData.push(t);
                    });
                });

                chartData = _.sortBy(chartData, 'endpoint');
                categories = _.pluck(chartData, 'endpoint');


                // Prevent the category names from being cut off
                chartData.forEach(function (d) {
                    d.endpoint = d.endpoint.split(' ');
                });

                this._categories = categories;
                this._data = chartData;
            };

            ResponseTimeGenerator.prototype.draw = function () {
                var self = this;

                this.chart = c3.generate({
                    bindto: self.bindto,
                    size: {
                        width: 884,
                        height: 600
                    },
                    data: {
                        json: self._data,
                        keys: {
                            x: 'endpoint',
                            value: self.RESPONSE_TIME_CATEGORY
                        },
                        type: 'bar'
                    },
                    bar: {
                        width: 8
                    },
                    color: {
                        pattern: ['#e97b72', '#5bccb7', '#f0d051', '#68aedf', '#b485c8']
                    },
                    axis: {
                        rotated: true,
                        x: {
                            type: 'category'
                        },
                        y: {
                            label: {
                                text: 'Response Time(ms)',
                                position: 'outer-right'
                            },
                            tick: {
                                values: reportsUtils.tickValuesGenerator
                            },
                            padding: {
                                top: 20,
                                bottom: 10
                            },
                            default: [0, 9]
                        }
                    },
                    legend: {
                        show: false
                    },
                    grid: {
                        y: {
                            show: true
                        }
                    },
                    tooltip: {
                        format: {
                            title: function (idx) {
                                var name = self._data[idx].endpoint;
                                return Array.isArray(name) ? name.join(', ') : name;
                            },
                            name: function (name) {
                                var idLabelMapping = self.RESPONSE_TIME_CATEGORY_LABEL;
                                return idLabelMapping[name] || '';
                            }
                        }
                    }
                });

                resizeChart();
                this.customLegend(this.bindto, this.chart, this.RESPONSE_TIME_CATEGORY);


                function resizeChart() {
                    var minHeight = 600;

                    var AxisYHeight = (function () {
                        var elemAxis = d3.select(self.bindto + ' .c3-axis-y').node();
                        if (!elemAxis) {
                            return 0;
                        }
                        return elemAxis.getBBox().height;
                    })();

                    var chartHeight = self._data.length * (self.RESPONSE_TIME_CATEGORY.length * 8 + 28) + AxisYHeight;

                    self.chart.resize({
                        width: RCDPW.isAdminSite ? 800 : 640,
                        height: chartHeight > minHeight ? chartHeight : minHeight
                    });
                }
            };

            ResponseTimeGenerator.prototype.customLegend = function (selector, chart, categories) {
                var self = this;
                var options = {
                    idLabelMapping: self.RESPONSE_TIME_CATEGORY_LABEL
                };
                reportsCustomLegendGenerator(selector, chart, categories, options);

                reportsUtils.loadStickyLegend();
            };

            ResponseTimeGenerator.prototype.destroy = function () {
                reportsUtils.unloadStickyLegend();
                this.summary.destroy();

                if (this.chart instanceof c3.chart.fn.constructor) {
                    this.chart.destroy();
                }
            };

            ResponseTimeGenerator.prototype.updateRetrieveDate = function () {
                reportsUtils.updateRetrieveDate(this.retrieveDate);
            };

            return ResponseTimeGenerator;
        }
    ])

    .factory('reportsGenerators', [
        'reportsModels', 'ReportsGeneratorAPICall', 'ReportsGeneratorEndPoints',
        'ReportsGeneratorPermissions', 'ReportsGeneratorResponseTime', 'trackUtil', 'reportsUtils',
        function (reportsModels, ReportsGeneratorAPICall, ReportsGeneratorEndPoints,
                  ReportsGeneratorPermissions, ReportsGeneratorResponseTime, trackUtil, reportsUtils) {
            var generators = {
                request: ReportsGeneratorAPICall,
                code: ReportsGeneratorEndPoints,
                permission: ReportsGeneratorPermissions,
                time: ReportsGeneratorResponseTime
            };

            return {
                current: null,

                dispatch: function (options) {

                    reportsModels.durations.virtual();

                    var reportsType = reportsModels.types.select();
                    var reportsContext = reportsModels.contexts.select();
                    var duration = reportsModels.durations.select();

                    this.current && this.current.destroy();

                    updateBindtoElementClassName();

                    if (options.track) {
                        var trackPageName = [
                            'Analytics',
                            reportsType.label,
                            reportsContext.text,
                            duration.label
                        ].join(':');

                        trackUtil.logPageView(trackPageName);
                    }
                    options.retrieve && this.clean();

                    var Generator = generators[reportsType.value];
                    this.current = new Generator({
                        appId: options.appId,
                        duration: duration,
                        context: reportsContext.value,
                        bindto: options.bindto,
                        onClick: options.onClick,
                        noLoading: options.noLoading,
                        retrieve: options.retrieve,
                        drawCallback: options.drawCallback
                    });

                    return this.current;

                    // Add type class to chart wrap element.
                    function updateBindtoElementClassName() {
                        var $bindto = $(options.bindto);
                        var CHART_CLASS_NAME_PREFIX = 'application-reports-chart-';

                        $bindto.removeClass(function () {
                            var classNames = $bindto.attr('class').split(' ');
                            var toBeRemoved = _.filter(classNames, function (item) {
                                return item.indexOf(CHART_CLASS_NAME_PREFIX) >= 0;
                            });

                            return toBeRemoved.join(' ');
                        });
                        $bindto.addClass(CHART_CLASS_NAME_PREFIX + reportsType.value);
                    }
                },

                clean: function () {
                }
            };
        }
    ])

    .factory('reportsRenderer', ['reportsGenerators', 'reportsUtils', function (reportsGenerators, reportsUtils) {
        return function (appId, options) {
            options = options || {};
            var generator = reportsGenerators.dispatch({
                appId: appId,
                bindto: '.application-reports-chart',
                onClick: options.onClickHandler,
                noLoading: options.noLoading,
                track: !!options.track,
                retrieve: options.retrieve,
                drawCallback: options.drawCallback
            });
            generator.initialized ? generator.render() : generator.init();


        };
    }
    ])

    .factory('reportsUtils', ['$location', 'api', 'reportsModels',
        function ($location, api, reportsModels) {
            return {

                /**
                 * Set tick values for axes.
                 *
                 * @param {Array} domain - An array which includes 2 numbers: [start, end]
                 * @returns {Array} Tick values.
                 */
                tickValuesGenerator: function (domain) {
                    // Filter out all non-integer numbers
                    return _.filter(d3.scale.linear().domain(domain).ticks(), function (t) {
                        return t === Math.floor(t);
                    });
                },

                /**
                 * Add window on scroll listener to make the legend sticky to the fixed position of the window.
                 */
                loadStickyLegend: function () {
                    var $legend = $('.legend');
                    var $footer = $('.footer');
                    var legendTop = $legend.offset().top;
                    var footerTop = $footer.offset().top;
                    var legendHeight = $legend.height();

                    var spacing = 20;
                    var start = legendTop - spacing;
                    var end = footerTop - legendHeight - spacing;

                    var listener = this.legendStickyScroll = function () {
                        var y = $(window).scrollTop();
                        if (y > start) {
                            if (y < end) {
                                var topValue = y - legendTop + spacing + 'px';
                                $legend.addClass('fixed');
                                $legend.css('top', topValue);
                            }
                        } else {
                            $legend.removeClass('fixed');
                            $legend.css('top', '');
                        }
                    };

                    $(window).on('scroll', listener);
                },

                /**
                 * Remove window on scroll listener which makes the legend sticky to the fixed position of the window.
                 */
                unloadStickyLegend: function () {
                    var listener = this.legendStickyScroll;
                    listener && $(window).off('scroll', listener);
                },

                /**
                 * Fetch Application information using #appId
                 *
                 * @param {Function} appDetailsAPI - Function for calling app deatils API.
                 * @param {String} appId - Application ID.
                 * @param {Function} onSuccess - Callback on request success.
                 */
                fetchAppInfo: function (appDetailsAPI, appId, onSuccess) {
                    api.call(appDetailsAPI({
                        applicationId: appId,
                        simple: true
                    }), onSuccess);
                },

                /**
                 * Function to execute when connecting to Sumo Logic.
                 *
                 * @param {Object} response
                 * @param {Function} success
                 * @param {Function} [error]
                 */
                onSumoConnect: function (response, success, error) {
                    success = angular.isFunction(success) ? success : function () {
                    };
                    error = angular.isFunction(error) ? error : function () {
                        RCDPW.modal && RCDPW.modal.create().content(RCDPW.Lang.Reports.SUMO_CONNECT_ERROR).show();
                    };

                    response.reportStatus === 'Success' ? success(response) : error();
                },

                /**
                 * Update durations model and `duration` query string.
                 *
                 * @param {String} expectedDuration - duration id.
                 * @param {Boolean} [addQueryString] - whether to add query string or not.
                 * @return {Object} The duration which was actually activated.
                 */
                activateDuration: function (expectedDuration, addQueryString) {
                    var activeDuration = reportsModels.durations.select(expectedDuration);

                    addQueryString = addQueryString !== false;
                    addQueryString && this.updateQueryString('duration', activeDuration.id);

                    return activeDuration;
                },

                /**
                 * Update types model and `type` query string.
                 *
                 * @param {String} expectedType - type id.
                 * @param {Boolean} [addQueryString] - whether to add query string or not.
                 * @return {Object} The type which was actually activated.
                 */
                activateType: function (expectedType, addQueryString) {
                    var activeType = reportsModels.types.select(expectedType);

                    addQueryString = addQueryString !== false;
                    addQueryString && this.updateQueryString('type', activeType.id);

                    return activeType;
                },

                /**
                 * Update contexts model and `context` query string.
                 *
                 * @param {String} expectedContext - context id.
                 * @param {Boolean} [addQueryString] - whether to add query string or not.
                 * @return {Object} The context which was actually activated.
                 */
                activateContext: function (expectedContext, addQueryString) {
                    var activeContext = reportsModels.contexts.select(expectedContext);

                    addQueryString = addQueryString !== false;
                    addQueryString && this.updateQueryString('context', activeContext.id);

                    return activeContext;
                },

                updateQueryString: function (search, value) {
                    $location.search(search, value);
                    $location.replace();
                },

                /**
                 * Judge whether the specified duration with specified type is available or not, according to the rule.
                 *
                 * @param {String} type - type id.
                 * @param {String} duration - duration id.
                 * @returns {boolean} True if the specified duration with specified type is unavailable.
                 */
                isDurationUnavailable: function (type, duration) {
                    var unavailableDuration = {
                        'code': ['0'],
                        'permission': ['0'],
                        'time': ['0']
                    };
                    return _.includes(unavailableDuration[type], duration);
                },

                /**
                 * Check if given #date is a valid duration date format.
                 *
                 * @param {String} date
                 * @returns {boolean|*}
                 */
                isDurationDateValid: function (date) {
                    return /^\d{4}-\d{1,2}-\d{1,2}$/.test(date) && moment(date, 'YYYY-MM-DD').isValid();
                },

                /**
                 * Add specific date into durations model.
                 *
                 * @param date
                 * @returns {*}
                 */
                addDateDuration: function (date) {
                    reportsModels.durations.remove(function (item) {
                        return item.type === 'date';
                    });

                    var selectedDate = moment(date);
                    var selectedDateId = selectedDate.format('YYYY-MM-DD');
                    var selectedDateLabel = selectedDate.format('YYYY/MM/DD');

                    return reportsModels.durations.add({
                        id: selectedDateId,
                        from: moment.utc(selectedDateId),
                        to: moment.utc(selectedDateId).add(1, 'days'),
                        value: 24,
                        label: selectedDateLabel,
                        type: 'date',
                        virtual: false
                    });
                },

                /**
                 * Find the first duration of the type that is not disabled, and activate it.
                 *
                 * @param {String} type - type id.
                 */
                activateAvailableDuration: function (type) {
                    var self = this;
                    var queryDurations = reportsModels.durations.all();
                    var firstAvailableDuration = _.find(queryDurations, function (duration) {
                        return !self.isDurationUnavailable(type, duration.id);
                    });
                    this.activateDuration(firstAvailableDuration.id);
                },

                isSummaryMultiline: function () {
                    var activeType = reportsModels.types.select();
                    return {
                        'request': true
                    }[activeType.id] || false;
                },

                isCurrentContext: function (statusId) {
                    return reportsModels.contexts.select().id === statusId;
                },

                isProduction: function () {
                    return isCurrentStatusIn({
                        context: ['Production']
                    });
                },

                showSummaryDurationTooltip: function () {
                    return isCurrentStatusIn({
                        context: ['Production'],
                        duration: ['0', '1']
                    });
                },

                getCacheStartTimes: function () {
                    var endTime = moment.utc();
                    var subtraction = {
                        WEEKLY: 7,
                        MONTHLY: 30,
                        get: function (type) {
                            var diff = this[type];

                            if (!diff) {
                                RCDPW.console.error('Invalid Subtraction Type.');
                                return;
                            }
                            return diff;
                        }
                    };

                    return [
                        moment(endTime).subtract(subtraction.get('WEEKLY'), 'days').format(),
                        moment(endTime).subtract(subtraction.get('MONTHLY'), 'days').format(),
                        moment(endTime).subtract(subtraction.get('WEEKLY') - 1, 'days').format(),
                        moment(endTime).subtract(subtraction.get('MONTHLY') - 1, 'days').format()
                    ];
                },

                updateRetrieveDate: function (retrieveDate) {
                    var $retrieveLastUpdated = $('.application-reports-retrieve-last-updated');

                    if (retrieveDate) {
                        retrieveDate = moment(retrieveDate).utc().format('YYYY-MM-DD, HH:mm:ss UTC');
                        $retrieveLastUpdated.show();
                        $('.application-reports-retrieve-date').html(retrieveDate);
                    } else {
                        $retrieveLastUpdated.hide();
                    }
                },
            };

            function isCurrentStatusIn(condition) {
                var activeContext = reportsModels.contexts.select();
                var activeType = reportsModels.types.select();
                var activeDuration = reportsModels.durations.select();

                var expectedContexts = condition.context || [activeContext.id];
                var expectedTypes = condition.type || [activeType.id];
                var expectedDurations = condition.duration || [activeDuration.id];

                return _.includes(expectedContexts, activeContext.id) &&
                    _.includes(expectedTypes, activeType.id) &&
                    _.includes(expectedDurations, activeDuration.id);
            }
        }
    ])

    .factory('ReportsController', [
        '$timeout', 'reportsModels', 'reportsRenderer', 'reportsUtils', 'reportsGenerators', 'organizationService',
        function ($timeout, reportsModels, reportsChartRenderer, reportsUtils, reportsGenerators, organizationService) {
            return function ($scope, $routeParams, $location, appDetailsAPI, redirectIfNeeded) {
                var self = this;
                var appId = $routeParams.id;
                var locationSearch = $location.search();

                // TODO: Break the coupling between onClickHandlers and type model. Howie
                var chartClickHandlers = {
                    request: function (d) {
                        $timeout(function () {
                            var selectedDateDuration = reportsUtils.addDateDuration(d.x);

                            reportsUtils.activateDuration(selectedDateDuration.id);
                            renderReportsChart();
                        });
                    }
                };

                $scope.application = {};
                $scope.$watch('application.status', function () {
                    if (!$scope.application.status) {
                        return;
                    }

                    reportsUtils.activateContext($scope.application.status);
                    renderReportsChart();
                });

                var activeType = reportsUtils.activateType(locationSearch.type);
                var activeDuration = reportsUtils.isDurationDateValid(locationSearch.duration) ?
                    reportsUtils.activateDuration(
                        reportsUtils.addDateDuration(locationSearch.duration).id
                    ) :
                    reportsUtils.activateDuration(locationSearch.duration);

                if (reportsUtils.isDurationUnavailable(activeType.id, activeDuration.id)) {
                    reportsUtils.activateAvailableDuration(activeType.id);
                }

                this.appId = appId;
                this.queryTypes = reportsModels.types.all();
                this.queryDurations = reportsModels.durations.all();
                this.query = function ($event, category, queryData) {
                    $event.preventDefault();

                    var activeType = reportsModels.types.select();
                    var activeDuration = reportsModels.durations.select();

                    if (category === 'type') {
                        if (reportsUtils.isDurationUnavailable(queryData, activeDuration.id)) {
                            reportsUtils.activateAvailableDuration(queryData);
                        }

                        reportsUtils.activateType(queryData);
                    }

                    if (category === 'duration') {
                        if (reportsUtils.isDurationUnavailable(activeType.id, queryData)) {
                            return;
                        }

                        reportsUtils.activateDuration(queryData);
                    }

                    renderReportsChart();
                };
                this.isDurationDisabled = function (durationId) {
                    var activeType = reportsModels.types.select();
                    return reportsUtils.isDurationUnavailable(activeType.id, durationId);
                };
                this.isSummaryMultiline = reportsUtils.isSummaryMultiline;
                this.switchContext = function (status) {
                    if (reportsUtils.isCurrentContext(status.id) || status.disabled) {
                        return;
                    }
                    reportsUtils.activateContext(status.id, true);
                    renderReportsChart();
                };
                this.isCurrentContext = reportsUtils.isCurrentContext;
                this.showSummaryDurationTooltip = reportsUtils.showSummaryDurationTooltip;
                this.retrieve = function () {
                    renderReportsChart(true);
                };
                this.getDataUpdateTooltip = function () {
                    var defaultTime = 'hour';
                    var elsDefaultTime = '5 minutes';
                    var mapping = {
                        '720': '4 hours',
                        '168': '5 minutes',
                        '24': '5 minutes'
                    };

                    var activeType = reportsModels.types.select();
                    var activeDuration = reportsModels.durations.select();

                    var isApiCalls = activeType.id === 'request';
                    var isResponseTime = activeType.id === 'time';
                    var isMonthly = activeDuration.value === 720;

                    if (isResponseTime) {
                        return elsDefaultTime;
                    }

                    if (reportsUtils.isProduction()) {
                        return defaultTime;
                    }
                    return mapping[activeDuration.value] || defaultTime;
                };

                reportsUtils.fetchAppInfo(appDetailsAPI, appId, function (data) {
                    if (_.isFunction(redirectIfNeeded) && redirectIfNeeded(data.application)) {
                        return;
                    }
                    var appData = data.application;
                    var contextModel = reportsModels.contexts;
                    $scope.$emit('updateAppNav', appData);
                    self.appName = appData.name;
                    data.hasProductionReport && contextModel.update();
                    self.appStatusList = contextModel.all();
                    var activeContext = reportsUtils.activateContext(locationSearch.context);
                    $scope.application.status = activeContext.id;
                });

                // Remove reports query string when leaving reports page.
                $scope.$on('$locationChangeSuccess', function ($event, newUrl) {
                    if (newUrl.indexOf('/reports') === -1) {
                        $location.url($location.path());


                        // Clean cached generators.
                        reportsGenerators.clean();

                        // Reset Query Models
                        reportsModels.durations.reset();
                        reportsModels.contexts.reset();
                        reportsModels.types.reset();
                    }
                });

                function getOnClickHandler() {
                    return chartClickHandlers[reportsModels.types.select().id];
                }

                function renderReportsChart(retrieve) {
                    reportsChartRenderer(appId, {
                        onClickHandler: getOnClickHandler(),
                        track: true,
                        retrieve: !!retrieve
                    });
                }
            };
        }
    ])

    .factory('AppDashboardReportsController', [
        'reportsModels', 'reportsGenerators', 'reportsRenderer', 'reportsUtils', 'organizationService',
        function (reportsModels, reportsGenerators, reportsRenderer, reportsUtils, organizationService) {
            return function ($scope, $routeParams, ctrl) {
                var appId = $routeParams.id;

                var deregister = $scope.$watch('application', function (newVal) {
                    if (!_.isUndefined(newVal)) {
                        updateReportsData($scope);
                        deregister();
                    }
                });

                ctrl.switchContext = function (status) {
                    if (reportsUtils.isCurrentContext(status.id) || status.disabled) {
                        return;
                    }
                    reportsUtils.activateContext(status.id, false);

                    showLoading();
                    reportsRenderer(appId, {
                        noLoading: true,
                        drawCallback: hideLoading,
                    });
                };
                ctrl.isCurrentContext = reportsUtils.isCurrentContext;
                ctrl.isSummaryMultiline = reportsUtils.isSummaryMultiline;
                ctrl.showSummaryDurationTooltip = reportsUtils.showSummaryDurationTooltip;

                $scope.$on('$locationChangeSuccess', function ($event, newUrl) {
                    if (!_.includes(newUrl, '/application-dashboard/' + appId)) {
                        // Clean cached generators.
                        reportsGenerators.clean();

                        // Reset Query Models
                        reportsModels.durations.reset();
                        reportsModels.contexts.reset();
                        reportsModels.types.reset();
                    }
                });

                function updateReportsData(data) {
                    var contextModel = reportsModels.contexts;
                    data.hasProductionReport && contextModel.update();
                    ctrl.appStatusList = contextModel.all();

                    reportsUtils.activateType('request', false);
                    reportsUtils.activateDuration('1', false);

                    showLoading();
                    reportsRenderer(appId, {
                        noLoading: true,
                        track: false,
                        drawCallback: hideLoading,
                    });
                }

                function showLoading() {
                    ctrl.showReportLoading = true;
                }

                function hideLoading() {
                    ctrl.showReportLoading = false;
                }
            };
        }
    ])


    /**
     * REPORTS Namespace.
     * Service exposes controllers.
     */
    .factory('REPORTS', ['ReportsController', 'AppDashboardReportsController',
        function (ReportsController, AppDashboardReportsController) {
            return {
                Controller: ReportsController,
                AppDashboardReportsController: AppDashboardReportsController
            };
        }
    ]);

